"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAsisSessionStorageV2 = void 0;
const web_1 = require("../../web");
class MbAsisSessionStorageV2 extends web_1.MbSessionStorage {
    constructor() {
        super(...arguments);
        this.getSavedSessionData = () => {
            let sessionData = this.getStorageData();
            const accessToken = this.storage.getItem('tokenCredential');
            sessionData = { ...sessionData, accessToken };
            if (this.checkSecurityData(sessionData)) {
                return sessionData;
            }
            return null;
        };
    }
    saveSessionData(newData) {
        super.saveSessionData(newData);
        this.storage.setItem('tokenCredential', newData.accessToken);
        this.storage.removeItem('accessToken'); // Remove old key to avoid confusion
    }
    checkExpiresData(data) {
        return !!data?.expiresIn;
    }
}
exports.MbAsisSessionStorageV2 = MbAsisSessionStorageV2;
//# sourceMappingURL=index.js.map